import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Inventory } from "../components/site/Inventory";
import { Services } from "../components/site/Services";
import { Contact } from "../components/site/Contact";
import { scrollToId } from "../lib/api";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const tm = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(tm);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Inventory />
      <Services />
      <Contact />
    </main>
  );
}
